/**
 * RESPONSIBILITY: the @Color column of a @List row.
 *
 * The same swatch-plus-hex the full-size control gives, at row height. Without it the
 * cell lookup fell through to text, so a colour inside a row was a box you typed
 * `#4a7c59` into and could not see — silently, because a fallback cannot warn.
 */
import { str, type Cell } from './cell-types';

/** What <input type=color> requires. Anything else and the swatch goes black. */
const HEX = /^#[0-9a-fA-F]{6}$/;

const ColorCell: Cell['render'] = ({ value, onChange, id }) => {
  const text = str(value);
  return (
    <div className="ctl-cell-color">
      <input
        type="color" className="ctl-cell-swatch"
        // The swatch cannot show a half-typed value, so it shows black until the hex is
        // complete. The text field is the one that holds what the editor actually typed.
        value={HEX.test(text) ? text : '#000000'}
        onChange={(e) => onChange(e.target.value)}
        aria-hidden="true" tabIndex={-1}
      />
      <input
        id={id} type="text" className="ctl-input mono" value={text}
        placeholder="#000000" maxLength={7}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

export const colorCell: Cell = { render: ColorCell, basis: () => '14ch' };
